<template>
  <footer class="footer" :class="{ 'dark-mode': isDarkMode }">
    <div class="footer-content">
      <div class="footer-section">
        <h3 class="footer-title">抖音SEO教学</h3>
        <p class="footer-description">专业的抖音搜索引擎优化学习平台，助您获取精准流量，提升内容曝光度。</p>
      </div>
      
      <div class="footer-section links-section">
        <h3 class="footer-title">快速链接</h3>
        <div class="footer-links">
          <router-link to="/" class="footer-link">首页</router-link>
          <router-link to="/theory/intro" class="footer-link">理论学习</router-link>
          <router-link to="/practice/account" class="footer-link">实战指导</router-link>
          <router-link to="/tools" class="footer-link">工具箱</router-link>
          <router-link to="/cases" class="footer-link">成功案例</router-link>
        </div>
      </div>
      
      <div class="footer-section contact-section">
        <h3 class="footer-title">联系我们</h3>
        <div class="contact-info">
          <p><i class="el-icon-message"></i> 邮箱：contact@douyinseo.com</p>
          <p><i class="el-icon-phone"></i> 电话：400-123-4567</p>
        </div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>© 2025 抖音SEO教学平台 版权所有</p>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SiteFooter',
  computed: {
    ...mapGetters(['isDarkMode'])
  }
}
</script>

<style scoped>
.footer {
  background-color: #f5f7fa;
  padding: 40px 20px 20px;
  transition: all 0.3s ease;
}

.dark-mode.footer {
  background-color: #16162a;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  flex: 1;
  min-width: 250px;
  margin-bottom: 30px;
  padding: 0 15px;
}

.footer-title {
  font-size: 18px;
  margin-bottom: 15px;
  color: #7957d5;
}

.footer-description {
  line-height: 1.6;
  margin-bottom: 15px;
}

.footer-links {
  display: flex;
  flex-direction: column;
}

.footer-link {
  margin-bottom: 10px;
  color: inherit;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #7957d5;
}

.contact-info p {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.contact-info i {
  margin-right: 10px;
  color: #7957d5;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.dark-mode .footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* 移动端样式 */
@media (max-width: 768px) {
  .footer {
    padding: 30px 15px 15px;
  }
  
  .footer-content {
    flex-direction: column;
  }
  
  .footer-section {
    margin-bottom: 25px;
    padding: 0;
  }
  
  .links-section {
    order: 3;
  }
  
  .footer-links {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .footer-link {
    margin-right: 15px;
    margin-bottom: 10px;
    font-size: 15px;
  }
  
  .footer-bottom {
    margin-top: 10px;
    padding-top: 15px;
    font-size: 14px;
  }
}
</style>
